import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09bbc5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "기초정보")
    ])
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "사원번호", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "이름", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "직위", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "주민번호", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "휴대폰번호", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "이메일", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "주소", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "은행명", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "계좌번호", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "예금주", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "입사일", -1))
const _hoisted_13 = { class: "pl-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "대표자 여부", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "사회보험적용", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "퇴사 및 삭제"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px"} }, "입력한 퇴사일에 맞춰 처리됩니다.")
    ])
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "퇴사일", -1))
const _hoisted_18 = {
  colspan: "2",
  class: "tar"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "사원을 선택해주세요.", -1))

import axios from 'axios';
import AdminEmpDelete from './AdminEmpDelete.vue';
import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useStore } from 'vuex';
interface FormItem {
  [key: string]: string | number | null | string[] | number[] | boolean | undefined;
}

interface WPTInfoType {
  sisul_code: string;
  emp_status: number;
  emp_num: string;
  emp_name: string;
  emp_job: string;
  emp_birth_num: string;
  emp_phone: string;
  emp_email: string;
  emp_addr: string;
  emp_bank: string;
  emp_bank_num: string;
  emp_bank_owner: string;
  emp_in_date: string;
  emp_out_date: string;
  emp_biz_gubun: string;
  emp_isBoss: number;
  emp_insu: string;
  ec_pay_type: string;
  ec_pay_month: number;
  ec_pay_time_type: string;
  ec_pay_time: number;
  work_period: string;
  work_shift: string | null;
  ec_day: number;
  ec_night: number;
}

interface SsECDEmpInfoType {
  emp_num: string;
  name: string;
  position: string;
  department: string;
}

interface PostcodeData {
  address: string;
}

interface PostcodeInstance {
  open: () => void;
}

interface PostcodeConstructor {
  new (options: { oncomplete: (data: PostcodeData) => void }): PostcodeInstance;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminEmpDetail',
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit
const doubleEmit = () => {
  emit('success');
}
const jobValue= [
'시설장',
'요양보호사',
'사회복지사',
'간호사',
'간호조무사',
'물리치료사',
'작업치료사',
'사무장',
'사무원',
'영양사',
'조리사',
'조리원',
'위생원',
'운전사',
'기타',
]
const bankValue= [
'기업은행',
'국민은행',
'외환은행',
'수협은행',
'농협은행',
'지역농협',
'우리은행',
'SC제일은행',
'서울은행',
'한국씨티은행',
'대구은행',
'부산은행',
'광주은행',
'제주은행',
'전북은행',
'경남은행',
'새마을금고연합회',
'신협중앙회',
'하나은행',
'신한은행',
'케이뱅크',
'카카오뱅크',
'토스뱅크'
]
const form = reactive({
  sisul_code : store.state.AdminSisulCode,
  emp_status: 0,
  emp_num: '',
  emp_name : '',
  emp_job : null as string | null,
  emp_birth_num : '',
  emp_phone : '',
  emp_email : '',
  emp_addr : '',
  emp_bank  : null as string | null,
  emp_bank_num  : '',
  emp_bank_owner  : '',
  emp_in_date : '',
  emp_out_date : '',
  emp_biz_gubun  : '',
  emp_isBoss : 0,
  emp_insu : [1,2,3,4],
  ec_pay_type : '',
  ec_pay_month: 0,
  ec_pay_time_type : '최저시급',
  ec_pay_time : 0,
  ec_day : 0,
  ec_night : 0,
  work_period : '',
  work_shift : null as string | null,
});

function unformatNumber(value: string | number | null) {
  return value?.toString().replace(/,/g, '');
}

// function addComma(number: string | number): string {
//   const num = Number(number);
//   if (isNaN(num)) return number.toString();
//   if (num === 0) return '0';
//   return num.toLocaleString();
// }

function clearFormatHP(item: FormItem, key: string) {
  const value = item[key];
  if (value === undefined || value === null) return;
  
  item[key] = unformatNumberHP(value.toString());
  if (item[key] === '0') {
    item[key] = '';
  }
}

function applyFormatHP(item: FormItem, key: string) {
  if (item[key] === '' || item[key] === null || item[key] === undefined) {
    item[key] = '';
  } else {
    if(key === 'emp_birth_num'){
      item[key] = formatEmpNumHP(item[key] as string);
    }else if(key === 'emp_phone'){
      item[key] = formatPhoneHP(item[key] as string);
    }
  }
}

function formatEmpNumHP(value: string){
  const number = parseFloat(value);
  if (!isNaN(number)) {
    return `${value.slice(0, 6)}-${value.slice(6)}`;
  }
  return value;
}

function formatPhoneHP(value: string){
  const number = parseFloat(value);
  if (!isNaN(number)) {
    return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
  }
  return value;
}

function unformatNumberHP(value: string | number | null) {
  return value?.toString().replace(/-/g, '');
}
    
const bossbirthstatus = ref(false);
const WPTInfo = ref<WPTInfoType | null>(null);

const changeSsECDEmpInfo = computed(() => {
  const SsECDEmpInfoComputed = store.state.SsECDEmpInfo as SsECDEmpInfoType | null;
  return SsECDEmpInfoComputed;
});

watch(changeSsECDEmpInfo, async (newValue: SsECDEmpInfoType | null) => {
  if (newValue) {
    bossbirthstatus.value = false;
    await getEmpContract();
  }
});

const getEmpContract = async () => {
  try {
    const empNum = store.state.SsECDEmpInfo?.emp_num;
    if(!empNum){
      form.emp_status = 1;
      form.emp_num = '';
      form.emp_name = '';
      form.emp_job = null;
      form.emp_birth_num = '';
      form.emp_phone = '';
      form.emp_email ='';
      form.emp_addr = '';
      form.emp_bank  = null;
      form.emp_bank_num  = '';
      form.emp_bank_owner  = '';
      form.emp_in_date = '';
      form.emp_out_date = '';
      form.emp_biz_gubun  = '';
      form.emp_isBoss =0;
      form.emp_insu = [1,2,3,4];
      form.ec_pay_type = '약정';
      form.ec_pay_time_type = '최저시급';
      form.ec_pay_month = 0;
      form.ec_pay_time =  0;
      form.work_period = '';
      form.work_shift = null;
      form.ec_day = 0;
      form.ec_night = 0;
      return;
    }
    const response = await axios.get(`/api/getEmpContract/${form.sisul_code}/${empNum}`);
    const responseData = response.data;
    if (responseData.length !== 0) {
      WPTInfo.value = responseData[0];
      if (WPTInfo.value) {
        form.sisul_code = WPTInfo.value.sisul_code;
        form.emp_status = WPTInfo.value.emp_status;
        form.emp_num = WPTInfo.value.emp_num || '';
        form.emp_name = WPTInfo.value.emp_name || '';
        form.emp_job = WPTInfo.value.emp_job || null;
        form.emp_birth_num = formatEmpNumHP(WPTInfo.value.emp_birth_num || '');
        form.emp_phone = formatPhoneHP(WPTInfo.value.emp_phone || '');
        form.emp_email = WPTInfo.value.emp_email || '';
        form.emp_addr = WPTInfo.value.emp_addr || '';
        form.emp_bank = WPTInfo.value.emp_bank;
        form.emp_bank_num = WPTInfo.value.emp_bank_num;
        form.emp_bank_owner = WPTInfo.value.emp_bank_owner;
        form.emp_in_date = WPTInfo.value.emp_in_date;
        form.emp_out_date = WPTInfo.value.emp_out_date;
        form.emp_biz_gubun = WPTInfo.value.emp_biz_gubun;
        form.emp_isBoss = WPTInfo.value.emp_isBoss;
        form.emp_insu = JSON.parse(WPTInfo.value.emp_insu);
        form.ec_pay_type = WPTInfo.value.ec_pay_type;
        form.ec_pay_month = Number(WPTInfo.value.ec_pay_month);
        form.ec_pay_time_type = WPTInfo.value.ec_pay_time_type;
        form.ec_pay_time = Number(WPTInfo.value.ec_pay_time);
        form.work_period = WPTInfo.value.work_period;
        form.work_shift = WPTInfo.value.work_shift || null;
        
        if(form.work_shift){
          if(form.work_shift === '주간근무'){
            form.ec_day = 1;
            form.ec_night = 0;
          }else if(form.work_shift === '야간근무'){
            form.ec_day = 0;
            form.ec_night = 1;
          }else if(form.work_shift === null){
            form.ec_day = 0;
            form.ec_night = 0;
          }else{
            form.ec_day = 1;
            form.ec_night = 1;
          }
        }
        
        form.ec_day = WPTInfo.value.ec_day;
        form.ec_night = WPTInfo.value.ec_night;
      }
      return responseData;
    } else {
      store.commit('setSsECDEmpInfo', 'notSelectStatus');
    }
  } catch (error) {
    console.error('errorMsg:', error);
  }
};

const setEmpDetail = async () => {
  if(!form.emp_name || !form.emp_job || !form.emp_in_date){
    alert('이름, 직위, 입사일은 필수입니다.')
    return;
  }
  try {
    form.ec_pay_time = Number(unformatNumber(form.ec_pay_time)) || 0;
    form.ec_pay_month = Number(unformatNumber(form.ec_pay_month)) || 0;
    form.emp_birth_num = unformatNumberHP(form.emp_birth_num) || '';
    form.emp_phone = unformatNumberHP(form.emp_phone) || '';

    const empNum = store.state.SsECDEmpInfo?.emp_num || 'notValueEmpNum';
    const response = await axios.post(`/api/setEmpDetail/${empNum}`, { form: form });
    const result = response.data;
    if (result.success === true) {
      await emit('success');
      await getEmpContract();
      alert('정상 처리되었습니다.');
    } else {
      alert('실패하였습니다. 관리자에게 문의해주세요.');
    }
  } catch (error) {
    alert('처리할 수 없습니다.');
    console.error(error);
  }
};

const birthNumComputed = computed(() => {
  const birthNum = form.emp_birth_num;
  if (!birthNum || birthNum.length < 6) {
    // 입력이 유효하지 않거나 너무 짧은 경우
    return null;
  }

  // 출생 연도와 월일을 가져옵니다.
  const yearPrefix = birthNum.substring(0, 2); // 앞 두 자리
  const month = parseInt(birthNum.substring(2, 4), 10); // 3번째와 4번째 자리
  const day = parseInt(birthNum.substring(4, 6), 10); // 5번째와 6번째 자리

  // 현재 연도, 월, 일을 가져옵니다.
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // getMonth()는 0부터 시작하므로 +1
  const currentDay = today.getDate();

  // 출생 연도 계산
  let birthYear = parseInt(yearPrefix, 10);
  if (birthYear > currentYear % 100) {
    // 1900년대 출생 (예: 95는 1995년)
    birthYear += 1900;
  } else {
    // 2000년대 출생 (예: 00은 2000년)
    birthYear += 2000;
  }

  // 만나이 계산
  let age = currentYear - birthYear;
  // 생일이 지났는지 확인하여 나이 조정
  if (month > currentMonth || (month === currentMonth && day > currentDay)) {
    age -= 1; // 생일이 지나지 않았으면 나이에서 1을 뺍니다.
  }
  return age;
});

watch(birthNumComputed, (newValue) => {
  if (bossbirthstatus.value === true) {
    if (newValue && newValue >= 60) {
      form.emp_insu = form.emp_insu.filter(value => value !== 1);
      if (newValue >= 65) {
        form.emp_insu = form.emp_insu.filter(value => value !== 3);
      }
    }else{
      if (!form.emp_insu.includes(1)) {
        form.emp_insu.push(1);
      }
      if (!form.emp_insu.includes(3)) {
        form.emp_insu.push(3);
      }
    }
  }else{
    return;
  }
});

const computedIsBoss = computed(() => {
  const cib = form.emp_isBoss;
  return cib;
});

watch(computedIsBoss, async (nv: number) => {
  if(bossbirthstatus.value === true){
    if (nv === 1) {
      form.emp_insu = form.emp_insu.filter(value => value !== 3 && value !== 4);
    } else if (nv === 0) {
      if (!form.emp_insu.includes(3)) {
        if(birthNumComputed.value && birthNumComputed.value < 65){
          form.emp_insu.push(3);
        }
      }
      if (!form.emp_insu.includes(4)) {
        form.emp_insu.push(4);
      }
    }
  }else{
    return;
  }
});

const findAddress = () => {
  const Postcode = (window as { daum?: { Postcode: PostcodeConstructor } }).daum?.Postcode;
  if (Postcode) {
    new Postcode({
      oncomplete: (data: PostcodeData) => {
        form.emp_addr = data.address;
      },
    }).open();
  }
};
onMounted (() => {
  getEmpContract();
}) 

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_unref(store).state.SsECDEmpInfo)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: "empDetails fontNotoSans400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_num,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.emp_num) = $event)),
                      "hide-details": "auto",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "사원등록이 완료되면 자동생성됩니다.",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_3,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.emp_name) = $event)),
                      "hide-details": "auto",
                      maxlength: "20",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "이름을 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_4,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_select, {
                      modelValue: form.emp_job,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.emp_job) = $event)),
                      items: jobValue,
                      "hide-details": "auto",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "- 선택 -"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (bossbirthstatus.value = true))
                }, [
                  _hoisted_5,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_birth_num,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.emp_birth_num) = $event)),
                      onFocus: _cache[4] || (_cache[4] = ($event: any) => (clearFormatHP(form, 'emp_birth_num'))),
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (applyFormatHP(form, 'emp_birth_num'))),
                      "hide-details": "auto",
                      maxlength: "13",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "숫자만 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_6,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_phone,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.emp_phone) = $event)),
                      onFocus: _cache[8] || (_cache[8] = ($event: any) => (clearFormatHP(form, 'emp_phone'))),
                      onBlur: _cache[9] || (_cache[9] = ($event: any) => (applyFormatHP(form, 'emp_phone'))),
                      "hide-details": "auto",
                      maxlength: "11",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "숫자만 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_7,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "email",
                      modelValue: form.emp_email,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.emp_email) = $event)),
                      "hide-details": "auto",
                      maxlength: "50",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "이메일을 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_addr,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.emp_addr) = $event)),
                      onClick: findAddress,
                      readonly: "",
                      "hide-details": "auto",
                      maxlength: "150",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "주소를 입력해주세요.",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_select, {
                      modelValue: form.emp_bank,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.emp_bank) = $event)),
                      items: bankValue,
                      "hide-details": "auto",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "- 선택 -"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_bank_num,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.emp_bank_num) = $event)),
                      "hide-details": "auto",
                      maxlength: "30",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "숫자만 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_text_field, {
                      type: "text",
                      modelValue: form.emp_bank_owner,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.emp_bank_owner) = $event)),
                      "hide-details": "auto",
                      maxlength: "20",
                      color: "indigo",
                      variant: "plain",
                      placeholder: "예금주를 입력해주세요."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      color: "indigo",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.emp_in_date) = $event)),
                      min: "2000-01-01",
                      max: "2099-12-31"
                    }, null, 512), [
                      [_vModelText, form.emp_in_date]
                    ])
                  ])
                ]),
                _createElementVNode("tr", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (bossbirthstatus.value = true))
                }, [
                  _hoisted_14,
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_radio_group, {
                      modelValue: form.emp_isBoss,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.emp_isBoss) = $event)),
                      inline: "",
                      "hide-details": "auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "예",
                          value: 1
                        }),
                        _createVNode(_component_v_radio, {
                          label: "아니오",
                          value: 0
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_15,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.emp_insu) = $event)),
                      value: 1
                    }, null, 512), [
                      [_vModelCheckbox, form.emp_insu]
                    ]),
                    _createTextVNode(" 국민연금 "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.emp_insu) = $event)),
                      value: 2
                    }, null, 512), [
                      [_vModelCheckbox, form.emp_insu]
                    ]),
                    _createTextVNode(" 건강보험 "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.emp_insu) = $event)),
                      value: 3
                    }, null, 512), [
                      [_vModelCheckbox, form.emp_insu]
                    ]),
                    _createTextVNode(" 고용보험 "),
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.emp_insu) = $event)),
                      value: 4
                    }, null, 512), [
                      [_vModelCheckbox, form.emp_insu]
                    ]),
                    _createTextVNode(" 산재보험 ")
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_table, { style: {"margin-top":"35px"} }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_17,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      color: "indigo",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.emp_out_date) = $event)),
                      min: "2000-01-01",
                      max: "2099-12-31"
                    }, null, 512), [
                      [_vModelText, form.emp_out_date]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_18, [
                    _createVNode(AdminEmpDelete, {
                      item: form,
                      onSuccess: _cache[23] || (_cache[23] = ($event: any) => (doubleEmit()))
                    }, null, 8, ["item"])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            onClick: setEmpDetail,
            color: "#333",
            style: {"font-size":"17px","width":"100%","min-height":"50px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("사원정보저장")
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        style: {"display":"flex","align-items":"center","justify-content":"center","height":"200px"}
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }))
}
}

})